import React, { PureComponent } from 'react';
import {
    Card, CardBody, Col, Nav, NavItem, NavLink, TabContent, TabPane, Button, Row, Spinner,ButtonToolbar,Modal
} from 'reactstrap';
import classnames from 'classnames';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import MUIDataTable from "mui-datatables";
import * as actions from '../../../Store/actions/index';
import { withTranslation } from 'react-i18next';
import Modals from './modals/modals';
import { Icon, Tooltip } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import Chips from 'react-chips';
import Input from '@material-ui/core/TextField';
import moment from 'moment-timezone';
// import { Row } from 'react-data-grid';
import * as ChangeAppLanguageFront from '../Layout/ChangeAppLanguageFront';
import { createTheme, MuiThemeProvider } from '@material-ui/core/styles';
let tlang  = ChangeAppLanguageFront.translateLanguage;

moment.tz.setDefault('Europe/Paris');

//start language
const PLANREQ_PLANNAME_KEY = tlang('plan_request_plan_name') || 'Plan Name';
const PLANREQ_CMPNAME_KEY = tlang('plan_request_company_name') || 'Company Name';
const PLANREQ_COST_KEY = tlang('plan_request_cost') || 'Cost';
const PLANREQ_REQDATE_KEY = tlang('plan_request_request_date') || 'Request Date';
const MASTERS_ACTIONS_KEY = tlang('masters_actions') || 'Actions';
const PLANREQ_COMMENT_KEY = tlang('plan_request_comment') || 'Comment';
const PLANREQ_EXPDATE_KEY = tlang('plan_request_expdate') || 'Expiry Date';
const RENEWBTN_KEY = tlang('renew_btn') || 'Renew';
const EXTENDBTN_KEY = tlang('extend_btn') || 'Extend';
const PLANREQUEST_KEY = tlang('plan_request') || 'Plan Request';
const PLANRENEW_KEY = tlang('plan_renew_list') || 'Plan Renew List';
const tooltip_accept = tlang('tooltip_accept') || 'Accept';
const tooltip_delete = tlang('tooltip_delete') || 'Delete';
const users_with_plan = tlang('users_with_plan') || 'Users with plan';
const user_request_company_address = tlang('user_request_company_address') || 'Address';
const USERREQUEST_CMPNAME_KEY = tlang('user_request_company_name') || 'Name of Company';
const USERREQUEST_EMAIL_KEY = tlang('user_request_email') || 'Email';
const USERREQUEST_NUMBER_KEY = tlang('user_request_number') || 'Number';
const USERREQUEST_ACTION_KEY = tlang('user_request_actions') || 'Actions';
const USERREQUEST_SRNO_KEY = tlang('user_request_srno') || 'Sr.No';
const sort_text = tlang('sort_text') || 'Sort';
const rows_per_page_text = tlang('rows_per_page_text') || 'Rows per page:';
const no_match_record_found = tlang('no_match_record_found') || 'Sorry, no matching records found';
const search_text = tlang('search_text') || 'Search';
const user_request_email = tlang('user_request_email') || 'Email';
const user_request_number = tlang('user_request_number') || 'Number';
const user_request_actmngrname = tlang('user_request_actmngrname') || 'Account Manager';
const user_request_country = tlang('user_request_country') || 'Country';
const user_plan_label_staff = tlang('user_plan_label_staff') || 'Plan';
const plan_request_expdate = tlang('plan_request_expdate') || 'Expiry Date';
const plan_history = tlang('plan_history') || 'Plan History';
const user_detail_step_modal_details = tlang('user_detail_step_modal_details') || 'Details';
const client_profile_company_name = tlang('client_profile_company_name') || 'Company name';
const update_plan_modal_planname = tlang('update_plan_modal_planname') || 'Plan Name';        
const user_request_status = tlang('user_request_status') || 'user_request_status';
const allDocumentsModal_Date = tlang('allDocumentsModal_Date') || 'Date';  
const common_btn_close = tlang('common_btn_close') || 'Close';
const client_free_plan = tlang('client_free_plan') || 'Free Plan';
const client_single_user_plan = tlang('client_single_user_plan') || 'Single user plan';
const client_small_company_plan = tlang('client_small_company_plan') || 'Small company plan';
const client_company_plan = tlang('client_company_plan') || 'Company plan';
const client_month = tlang('client_month') || 'Month';
//END

//master data module component
class PlanRequest extends PureComponent {
    static propTypes = {
        t: PropTypes.func.isRequired,
    };

    constructor() {
        super();
        this.state = {
            activeTab: '1',
            licenceEdit: {
                cost: 0,
                licenceid: "",
                licencename: ""
            },
            renewExtend: {
                type: "",
                companyid: "",
                price: "",
                date: moment(),
                comment: "",
                error: []
            },
            requestList : [],
            planRenewalList : [],
            acceptModal: false,
            rejectModal: false,
            planRenewExtendModal: false,            
            usersWithPlanList:[],
            planHistory:[],
            planList:[{
                planid: "AXD_PL_01",
                planname: client_free_plan,
            },{
                planid: "AXD_PL_02",
                planname: client_single_user_plan,
            },{
                planid: "AXD_PL_03",
                planname: client_small_company_plan,
            },{
                planid: "AXD_PL_04",
                planname: client_company_plan,
            }]
        };
    }

    componentDidMount() {
        if(this.props.location.state && this.props.location.state.requestKey ){
            const requestKey=this.props.location.state.requestKey   
            let request_tab=localStorage.getItem("plan_request_tab");
            if(request_tab!==requestKey ){
             localStorage.setItem("plan_request_tab",requestKey)
             this.setState({
                activeTab: requestKey
            },()=>this.forceUpdate())
            }
        } 
        //call initial actions
        this.props.getAllPlanReq(this.props.apolloClient.masters, [])
        this.setState({ 
            loading: true
        })

        this.props.getPlanRenewalList(this.props.apolloClient.client, [])

        if (localStorage.getItem("plan_request_tab")) {
            this.setState({
                activeTab: localStorage.getItem("plan_request_tab")
            });
        }
        this.props.getUsersWithPlanList(this.props.apolloClient.client, []);        
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.commonReducer) {
          if (this.props.commonReducer.refreshNotificationRedirectPage != "") {
            if(this.props.commonReducer.refreshNotificationRedirectPage == "/admin/planRequest"){
                this.componentDidMount();
                this.props.currentNotificationRedirectPageUrl('');
            }
          }
        }
    }

    getLagugagewiseName=(id)=>{
        let findTemplate = this.state.planList.filter(temp=>temp.planid==id)
        if(findTemplate.length>0){
            return findTemplate[0].planname
        }
    }

    componentWillReceiveProps(props) {
        if (props.masterReducer.planRequestDetails) {
        this.setState({
                planRequestDetails: props.masterReducer.planRequestDetails
            })
        }

        this.setState({
            userAccess: props.authReducer.userData.accesspages.user_request
        })
        //recive users pending request
        if (props.userReducer.requestList) {
            this.setState({
                requestList: props.userReducer.requestList
            })
        }

        //recive plan renew list
        if (props.masterReducer.planRenewalList) {
            this.setState({
                planRenewalList: props.masterReducer.planRenewalList
            })
        }

        // will recieve notifications data
        if (props.notification) {
            this.setState({
                loading: false
            })
            if (props.notification.success) {
                this.setState({
                    rejectModal: false,
                    acceptModal: false,
                    planRenewExtendModal: false
                })
            }
        }

        if (props.masterReducer.usersWithPlanList) {
            this.setState({
                usersWithPlanList: props.masterReducer.usersWithPlanList
            })
        }
        if (props.masterReducer.planHistory) {
            this.setState({
                planHistory: props.masterReducer.planHistory
            })
        }
    }

    toggle = tab => {
        const { activeTab } = this.state;
        if (activeTab !== tab) {
          this.setState(
            {
              activeTab: tab
            },
            () => localStorage.setItem("plan_request_tab", tab)
          );
        }
      };

    renderLicenceList = () => {
        let data = [];

        if (this.state.planRequestDetails) {
            this.state.planRequestDetails.map((val,index) => {
                data.push([
                    index + 1,
                   this.getLagugagewiseName(val.planid),
                    // val.companyname,
                    val.displayname,
                    '$' + val.planprice,
                    val.month,
                    // val.requesteddate,
                    moment.unix(val.requesteddate).format("DD/MM/YYYY HH:mm"),
                    val
                ])
            })
        }
        return data
    }

    rejectPlanRequest = () => {

        let req = {
            id: this.state.statusData._id,
            status: "reject"
        }
        this.props.acceptPlanRequest(this.props.apolloClient.masters, req)
        this.setState({ 
            loading: true
        })
    }

    approvePlanRequest = () => {

        let req = {
            id: this.state.statusData._id,
            status: "approve"
        }
        this.props.acceptPlanRequest(this.props.apolloClient.masters, req)
        this.setState({ 
            loading: true
        })
    }


    toggleRejectPlanReqModal = (value) => {
        this.setState({
            rejectModal: !this.state.rejectModal
        })
        if (value) {
            this.setState({
                statusData: value
            })
        }
    }


    toggleAcceptPlanReqModal = (value) => {
        this.setState({
            acceptModal: !this.state.acceptModal
        })
        if (value) {
            this.setState({
                statusData: value
            })
        }
    }

     //render table data
     renderPlanRenewalList = (data) => {
        let renderData = [];
        data.map((val, index) => {
            let setDate = moment.unix(val.expirydate)
            var str = val.comment;
            var n = str.length;
            var comment = n > 30 ? str.substring(0,30)+"..." : str;
            renderData.push([
                index + 1 ,
                val.company_name,
                this.getLagugagewiseName(val.planid), 
                comment,
                moment(setDate).format("DD/MM/YYYY HH:mm"),
                val
            ])
        })
        return renderData
    }


    handleChange = (name) => event => {

        let value = ""; 
        if(name === "date"){
            value = event
        }else{
            value = event.target.value
        }
        let renewExtend = this.state.renewExtend
        renewExtend[name] = value
        
        this.setState({
            renewExtend
        }, () => this.forceUpdate())
    }

    togglePlanRenewExtendModal = (value,type) => {
        let price = ""
        if(type === "renew"){
            price = value.price
        } 

        let renewExtend = this.state.renewExtend
        renewExtend['price'] = price
        renewExtend['comment'] = ""
        renewExtend['error'] = []
        renewExtend['date'] = moment()
        if (value) {
            renewExtend['companyid'] = value.company_id
            renewExtend['type'] = type
        }
        this.setState({
            renewExtend,
            planRenewExtendModal: !this.state.planRenewExtendModal
        },()=>this.forceUpdate())
    }

    validateForm = () => {
        let renewExtend = this.state.renewExtend;
        let error = []
        if(renewExtend.type === "extend"){
            if (!renewExtend.price) {
                error.push('price');
            }
        }
        
        renewExtend['error'] = error
        this.setState({
            error
        })
        return error;
    }


    saveRenewExtendPlanRequest = () => {
        
        let error = this.validateForm()
        let renewExtend = this.state.renewExtend;
        
        if(error.length == 0){
            let request = {
                type: renewExtend.type,
                companyid: renewExtend.companyid,
                price: renewExtend.price,
                date: renewExtend.type === "renew" ? "" : moment(renewExtend.date).format("X"),
                comment: renewExtend.comment
            }
            this.props.renewExtendPlanRequest(this.props.apolloClient.client, request)
            this.setState({ 
                loading: true
            })
        }else{
            console.log("error ", error);
        }
    }

    renderUsersWithPlanList = () => {
        let data = [];
        if (this.state.usersWithPlanList) {
            this.state.usersWithPlanList.map((val,index) => {
                data.push([
                    index + 1,
                    val.display_name,
                    val.email,
                    val.contact_number,
                    val.name,
                    val.registration_country,
                    val.plan?this.getLagugagewiseName(val.plan.planid):"-", 
                    val.plan && val.plan.expirydate?moment.unix(val.plan.expirydate).format("DD/MM/YYYY HH:mm"):"-",
                    val
                ])
            })
        }
        return data
    }
    renderPlanHistoryList = () => {
        let data = [];
        if (this.state.planHistory ) {
            this.state.planHistory.map(val => {
                data.push([
                    val.displayname,
                    val.planname,
                    val.status, 
                    val.requesteddate && val.requesteddate?moment.unix(val.requesteddate).format("DD/MM/YYYY HH:mm"):"-",                    
                ])
            })
        }
        return data
    }
    togglePlanHistoryModal = (event,details) => {
        let companyname = ""        
        if(details){ 
            let request = {
                companyname:details.company_name
            }
            this.props.getCompanyWisePlanHistory(this.props.apolloClient.masters,request)            
            this.setState({
                loading:true
            })
        }
        this.setState({
            planHistoryModal:!this.state.planHistoryModal
        })
    }
    render() {
        const { t } = this.props;

        const activeTab  = this.state.activeTab;
        const licenceColumns = [
            { name: USERREQUEST_SRNO_KEY },
            { name: PLANREQ_PLANNAME_KEY },
            { name: PLANREQ_CMPNAME_KEY },
            { name: PLANREQ_COST_KEY },
            { name: client_month },
            { name: PLANREQ_REQDATE_KEY },
            {
                name: MASTERS_ACTIONS_KEY,
                options: {
                    filter: false,
                    customBodyRender: (value) => {
                        return ( 
                            <div>
                                <Button className={"system-btn clear-border"} outline={true} color={'success'} onClick={() => this.toggleAcceptPlanReqModal(value)}>
                                    <Tooltip title={tooltip_accept}><Icon>done</Icon></Tooltip>
                                </Button>
                                <Button className={"system-btn clear-border"} outline={true} color={'success'} onClick={() => this.toggleRejectPlanReqModal(value)}>
                                    <Tooltip title={tooltip_delete}><Icon>delete</Icon></Tooltip>
                                </Button>
                            </div>
                        );

                    }
                }
            }
        ];

        const renewalColumns = [
            // { name: t('Sr.No.') },
            { name: USERREQUEST_SRNO_KEY },
            { name: PLANREQ_CMPNAME_KEY },
            { name: PLANREQ_PLANNAME_KEY },
            { name: PLANREQ_COMMENT_KEY },
            { name: PLANREQ_EXPDATE_KEY },
            {
                name: MASTERS_ACTIONS_KEY,
                options: {
                    filter: false,
                    customBodyRender: (value) => {
                        return ( 
                            <div>
                                <Button
                                    className={"add-new-btn"}
                                    color={"success"}
                                    onClick={() => this.togglePlanRenewExtendModal(value, "renew")}
                                >
                                    {RENEWBTN_KEY}
                                </Button>
                                <Button
                                    style={{ marginTop : "2px" }}
                                    className={"add-new-btn"}
                                    color={"success"}
                                    onClick={() => this.togglePlanRenewExtendModal(value, "extend")}
                                >
                                    {EXTENDBTN_KEY}
                                </Button>
                            </div>
                        );

                    }
                }
            }
        ];

        const userColumns = [
            {
                name: USERREQUEST_SRNO_KEY, options: {
                    filter: false,
                    sortDirection: 'desc'
                }
            },
            { name: USERREQUEST_CMPNAME_KEY },
            { name: USERREQUEST_EMAIL_KEY },
            { name: user_request_company_address },
            { name: USERREQUEST_NUMBER_KEY },
            {
                name: USERREQUEST_ACTION_KEY,
                options: {
                    filter: false,
                    customBodyRender: (value) => {
                        if (value) {
                                return (<>
                                        <>
                                        <Button
                                            className={"add-new-btn"}
                                            color={"success"}
                                            onClick={() => this.togglePlanRenewExtendModal(value, "renew")}
                                        >
                                            {RENEWBTN_KEY}
                                        </Button>
                                        <Button
                                            style={{ marginTop : "2px" }}
                                            className={"add-new-btn"}
                                            color={"success"}
                                            onClick={() => this.togglePlanRenewExtendModal(value, "extend")}
                                        >
                                            {EXTENDBTN_KEY}
                                        </Button>
                                        </>
                                </>
                                );
                        }
                    } 
                }
            },
        ];


        const options = {
            filterType: 'checkbox',
            selectableRows: "none",
            print: false,
            download: false,
            viewColumns: false,
            filter: false,
            responsive: "stacked",
            textLabels: {
                body: {
                  noMatch: no_match_record_found,
                  toolTip: sort_text
                },
                pagination: {
                  rowsPerPage: rows_per_page_text,
                },
                toolbar: {
                  search: search_text
                },
            },    
        };

        const usersWithPlansColumns = [
            { name: USERREQUEST_SRNO_KEY,
                options: {
                    filter: false,
                } 
            },
            { name: PLANREQ_CMPNAME_KEY,
                options: {
                    filter: false,
                }
            },
            { name: user_request_email,
                options: {
                    filter: false,
                }
            },
            { name: user_request_number,
                options: {
                    filter: false,
                }
            },
            { name: user_request_actmngrname,
                options: {
                    filter: false,
                }
            },
            { name: user_request_country,
                options: {
                    filter: false,
                } 
            },
            { name: user_plan_label_staff,
                options: {
                filter: true,
                filterList: [],
                customFilterListOptions: {
                   render: v => `${user_plan_label_staff}: ${v}` 
                },
                } 
            },
            { name: plan_request_expdate,
                options: {
                    filter: false,
                } 
            },
            {
            name: user_detail_step_modal_details,
            options: {
                filter: false,
                customBodyRender: (value) => {
                    return ( 
                        <>
                            <Button
                                title={plan_history}
                                className={"system-btn clear-border"}
                                color={"success"}
                                outline={true}
                                onClick={(event) => this.togglePlanHistoryModal(event,value)}
                            >
                                <Tooltip title={plan_history}><Icon>remove_red_eye</Icon></Tooltip>
                            </Button>
                        </>
                    );

                }
            }
            }
        ];
 
        const usersWithPlansOptions = {
            filterType: 'dropdown',
            selectableRows: "none",
            print: false,
            download: false,
            viewColumns: false,
            filter: true,
            responsive: "stacked",
            textLabels: {
              body: {
                noMatch: no_match_record_found,
                toolTip: sort_text
              },
              pagination: {
                rowsPerPage: rows_per_page_text,
              },
              toolbar: {
                search: search_text
              },
            },
          };


          const planHistoryColumns = [
                { name: client_profile_company_name },
                { name: update_plan_modal_planname },
                { name: user_request_status },
                { name: allDocumentsModal_Date },
            ];

            const theme = createTheme({
                typography: {
                  useNextVariants: true,
                  fontSize: 13,
                },
              palette: {
                primary: {
                  light: '#E64823',
                  main: '#E64823',
                  dark: '#E64823',
                  contrastText: '#fff',
                },
              },
              overrides: {
                MuiPaper: {
                    elevation4: {
                      boxShadow: "none",
                    },
                    root: {
                      padding: "0px 20px 20px 20px"
                    }
                },
                MuiTableHead: {
                     
                },
                MUIDataTableFilterList:{
                    root: { 
                       marginBottom:"10px"
                      }
                  },
                MuiTableCell: {
                     root:{
                        padding: "10px"
                    },
                    head: {
                      color: "#646777",
                      fontWeight: "700",
                      textAlign: 'left',
                      backgroundColor: "#fafbfe !important",
                      borderBottom: "1px solid #c6c6c6",
                      borderTop: "1px solid #c6c6c6",
                    }
                },
              }
            });

        return (
            <Col xs={12} md={12} lg={12} xl={12}>
                <h3 className="page-title" style={{ marginBottom: "20px" }}>
                  {PLANREQUEST_KEY}
                </h3>
                <Card>
                    <CardBody>
                    <div className="tabs tabs--bordered-top">
                            <div className="">
                                <Nav tabs>
                                    <NavItem>
                                        <NavLink
                                            className={classnames({ active: activeTab === '1' })}
                                            onClick={() => {
                                                this.toggle('1');
                                            }}
                                        >
                                            {PLANREQUEST_KEY}
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            className={classnames({ active: activeTab === '2' })}
                                            onClick={() => {
                                                this.toggle('2');
                                            }}
                                        >
                                            {PLANRENEW_KEY}
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            className={classnames({ active: activeTab === '3' })}
                                            onClick={() => {
                                                this.toggle('3');
                                            }}
                                        >
                                            {users_with_plan}
                                        </NavLink>
                                    </NavItem>
                                </Nav>
                                <TabContent activeTab={activeTab}>
                                    <TabPane tabId="1">
                                        <div className="div-spinner">{this.state.loading && <Spinner size="500" className="success" />}</div>
                                        {!this.state.loading && 
                                            <MuiThemeProvider theme={theme}>
                                            <MUIDataTable
                                            data={this.renderLicenceList()}
                                            columns={licenceColumns}
                                            options={options}
                                            />
                                            </MuiThemeProvider>
                                        }     
                                    </TabPane>
                                    <TabPane tabId="2">
                                        <div className="div-spinner">{this.state.loading && <Spinner size="500" className="success" />}</div>
                                        {!this.state.loading && 
                                            <MuiThemeProvider theme={theme}>
                                            <MUIDataTable
                                            data={this.renderPlanRenewalList(this.state.planRenewalList)}
                                            columns={renewalColumns}
                                            options={options}
                                            />
                                            </MuiThemeProvider>
                                    }  
                                    </TabPane>
                                    <TabPane tabId="3">
                                        <div className="div-spinner">{this.state.loading && <Spinner size="500" className="success" />}</div>
                                        {!this.state.loading && 
                                            <MuiThemeProvider theme={theme}>
                                            <MUIDataTable
                                                data={this.renderUsersWithPlanList()}
                                                columns={usersWithPlansColumns}
                                                options={usersWithPlansOptions}
                                            />
                                            </MuiThemeProvider>
                                        }  
                                    </TabPane>
                                </TabContent>
                            </div>
                        </div>

                        <Modal
                            isOpen={this.state.planHistoryModal}
                            toggle={(event) => this.togglePlanHistoryModal(event)}
                            className={`modal-dialog--success modal-dialog--header width__70 `}
                        >
                            <div className="modal__header">
                            <button
                                className="lnr lnr-cross modal__close-btn"
                                type="button"
                                onClick={(event) => this.togglePlanHistoryModal(event)}
                            />
                            <h4 className="bold-text  modal__title">{plan_history}</h4>
                            </div>
                            <div className="modal__body">
                            <div className="div-spinner">{this.state.loading && <Spinner size="500" className="success" />}</div>
                            {!this.state.loading && <MUIDataTable
                                data={this.renderPlanHistoryList()}
                                columns={planHistoryColumns}
                                options={options}
                            />}
                            </div>
                            <ButtonToolbar className="modal__footer">
                            <Button
                                color={"success"}
                                outline={true}
                                onClick={(event) => this.togglePlanHistoryModal(event)}
                            >
                            {common_btn_close}
                            </Button>
                            </ButtonToolbar>
                        </Modal>
                    </CardBody>
                </Card>
                {this.state.acceptModal &&
                    Modals.acceptPlanReqModal(this)
                }
                {this.state.rejectModal &&
                    Modals.rejectPlanReqModal(this)
                }
                {this.state.editPlanModal &&
                    Modals.updatePlan(this)
                }
                {this.state.planRenewExtendModal &&
                    Modals.planRenewExtendModal(this)
                }
            </Col>
        );
    }
}


PlanRequest.propTypes = {
    t: PropTypes.func.isRequired,
};

//load reducers
const mapStateToProps = state => {
    return {
        authReducer: state.authReducer,
        apolloClient: state.apolloClient,
        masterReducer: state.masterReducer,
        notification: state.notification,
        userReducer: state.userReducer,
        commonReducer: state.commonReducer,
    }
}

//Load actions
const mapDispatchToProps = dispatch => {
    return {
        getAllPlanReq: (client, request) => { dispatch(actions.getAllPlanReq(client, request)) },
        acceptPlanRequest: (client, request) => { dispatch(actions.acceptPlanRequest(client, request)) },
        renewExtendPlanRequest: (client, request) => { dispatch(actions.renewExtendPlanRequest(client, request)) },
        getPlanRenewalList: (client, request) => { dispatch(actions.getPlanRenewalList(client, request)) },
        getUsersWithPlanList: (client, request) => { dispatch(actions.getUsersWithPlanList(client, request)) },
        getCompanyWisePlanHistory: (client, request) => { dispatch(actions.getCompanyWisePlanHistory(client, request)) },
        currentNotificationRedirectPageUrl: (data) => {
            dispatch(actions.currentNotificationRedirectPageUrl(data));
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('common')(PlanRequest)); //export component
